import React, { Component } from 'react';
import { Panel } from 'react-bootstrap';

import './PriceCard.css';

class PriceCard extends Component {
  render() {
    const {
      title = "",
      price = 0,
      schedule = "monthly",
      features = [],
      footer,
      pcStyle = "default",
      disabled = false,
    } = this.props;

    const className = `PriceCard-container panel-${pcStyle}`
    return (
      <Panel className={className} style={{opacity: disabled ? 0.5 : 1}}>
        <Panel.Heading>
          <Panel.Title>{title}</Panel.Title>
        </Panel.Heading>
        <div className="PriceCard-body">
          <div className="PriceCard-price">
            <div className="PriceCard-dollar">${price}</div>
            <div>{schedule}</div>
          </div>
          <ul className="PriceCard-feature-list">
            {
              features.map((feature, index) => {
                return (
                  <li key={index} className="PriceCard-feature">
                    {feature}
                  </li>);
              })
            }
          </ul>
        </div>
        {this.renderFooter(footer)}
      </Panel>
    );
  }

  renderFooter = (footer) => {
    if (!footer) {
      return null;
    }
    return (
      <div className="PriceCard-footer">{footer}</div>
    )
  }
}

export default PriceCard;


// WEBPACK FOOTER //
// ./src/components/Shared/PriceCard.js